import * as types from "./actionTypes";
import axiosInstance from "pages/Utility/axiosInstance";

// =============================
// Fetch All Assignments (List)
// =============================
export const fetchAssignmentsRequest = (params = {}) => ({
  type: types.FETCH_ASSIGNMENTS_REQUEST,
  payload: params,
});

export const fetchAssignmentsSuccess = (data) => ({
  type: types.FETCH_ASSIGNMENTS_SUCCESS,
  payload: data,
});

export const fetchAssignmentsFailure = (error) => ({
  type: types.FETCH_ASSIGNMENTS_FAILURE,
  payload: error,
});

// =============================
// Fetch Single Assignment Details
// =============================
export const fetchAssignmentDetailsRequest = (id, params = {}) => ({
  type: types.FETCH_ASSIGNMENT_DETAILS_REQUEST,
  payload: { id, params },
});


export const fetchAssignmentDetailsSuccess = (data) => ({
  type: types.FETCH_ASSIGNMENT_DETAILS_SUCCESS,
  payload: data,
});

export const fetchAssignmentDetailsFailure = (error) => ({
  type: types.FETCH_ASSIGNMENT_DETAILS_FAILURE,
  payload: error,
});

// =============================
// Delete Assignment
// =============================
export const deleteAssignmentRequest = (id) => ({
  type: types.DELETE_ASSIGNMENT_REQUEST,
  payload: id,
});

export const deleteAssignmentSuccess = (data) => ({
  type: types.DELETE_ASSIGNMENT_SUCCESS,
  payload: data,
});

export const deleteAssignmentFailure = (error) => ({
  type: types.DELETE_ASSIGNMENT_FAILURE,
  payload: error,
});
